import { useEffect, useRef, useState, useCallback } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { MessageSquare, Send, Loader2, ArrowLeft } from "lucide-react";

export function MentorClientChats() {
  const [chats, setChats] = useState([]);
  const [active, setActive] = useState(null);
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const scrollRef = useRef(null);

  const loadChats = useCallback(async () => {
    try { const { data } = await api.get("/admin/mentor/chats"); setChats(data || []); } catch { /* ignore */ }
  }, []);
  useEffect(() => { loadChats(); const t = setInterval(loadChats, 8000); return () => clearInterval(t); }, [loadChats]);

  const openChat = async (c) => {
    setActive(c);
    try { const { data } = await api.get(`/admin/mentor/chats/${c.client_id}`); setMsgs(data.messages || []); loadChats(); }
    catch { /* ignore */ }
  };
  useEffect(() => {
    if (!active) return;
    const t = setInterval(async () => {
      try { const { data } = await api.get(`/admin/mentor/chats/${active.client_id}`); setMsgs(data.messages || []); } catch { /* ignore */ }
    }, 6000);
    return () => clearInterval(t);
  }, [active]);
  useEffect(() => { scrollRef.current?.scrollTo(0, scrollRef.current.scrollHeight); }, [msgs]);

  const reply = async () => {
    if (!text.trim() || !active) return;
    setBusy(true);
    try {
      await api.post(`/admin/mentor/chats/${active.client_id}/reply`, { text: text.trim() });
      setText("");
      const { data } = await api.get(`/admin/mentor/chats/${active.client_id}`); setMsgs(data.messages || []);
    } catch { /* ignore */ }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-3xl" data-testid="mentor-client-chats">
      <div className="flex items-center gap-2 mb-3"><MessageSquare className="h-4 w-4 text-[#00F593]" />
        <span className="font-heading font-semibold">Chat ak Kliyan</span></div>
      {!active ? (
        <div className="border border-[#222] bg-[#0F0F0F]" data-testid="mentor-chats-list">
          {chats.length === 0 ? <div className="p-8 text-center text-[#888] text-sm">Pa gen demann kliyan pou kounye a.</div> :
            chats.map((c) => (
              <button key={c.client_id} onClick={() => openChat(c)} data-testid={`mentor-chat-${c.client_id}`}
                className="w-full text-left px-4 py-3 border-b border-[#161616] last:border-0 hover:bg-[#141414] flex items-center justify-between">
                <div className="min-w-0">
                  <div className="font-heading font-semibold text-sm truncate">{c.client_name || c.client_email}</div>
                  <div className="font-mono-term text-[11px] text-[#666] truncate">{c.client_email}</div>
                </div>
                {c.unread > 0 && <span className="ml-2 shrink-0 h-5 min-w-5 px-1.5 rounded-full bg-[#FF3B30] text-white text-[10px] font-bold flex items-center justify-center">{c.unread}</span>}
              </button>
            ))}
        </div>
      ) : (
        <div className="border border-[#222] bg-[#0F0F0F] flex flex-col h-[460px]">
          <div className="border-b border-[#222] px-4 py-2.5 flex items-center gap-2">
            <button onClick={() => setActive(null)} data-testid="mentor-chat-back" className="text-[#888] hover:text-white"><ArrowLeft className="h-4 w-4" /></button>
            <span className="font-heading font-semibold text-sm">{active.client_name || active.client_email}</span>
          </div>
          <div ref={scrollRef} className="flex-1 overflow-y-auto p-4 space-y-3">
            {msgs.map((m) => (
              <div key={m.id} className={`flex ${m.from === "mentor" ? "justify-end" : "justify-start"}`}>
                <div className={`max-w-[75%] rounded-2xl px-3.5 py-2 ${m.from === "mentor" ? "bg-[#00F593] text-black" : "bg-[#161616] text-[#eee]"}`}>
                  <div className="text-[10px] font-mono-term uppercase opacity-70 mb-0.5">{m.from === "mentor" ? m.name : "Kliyan"}</div>
                  <div className="text-sm whitespace-pre-wrap">{m.text}</div>
                </div>
              </div>
            ))}
          </div>
          <div className="border-t border-[#222] p-3 flex items-center gap-2">
            <Input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && reply()}
              data-testid="mentor-chat-input" placeholder="Reponn kliyan an..." className="bg-[#0A0A0A] border-[#222] rounded-sm h-11" />
            <Button onClick={reply} disabled={busy} data-testid="mentor-chat-send"
              className="h-11 rounded-sm bg-white text-black hover:bg-[#e5e5e5] px-4">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
